var map = {
	"./android-icon.svg": 2171,
	"./app-img.png": 2172,
	"./app-qr-code-bg.png": 2173,
	"./apple-icon.svg": 2174,
	"./contact-bg.png": 2175,
	"./contact-us-bg.jpg": 2176,
	"./contact-us-main-bg.webp": 2177,
	"./qr-bg.png": 2178
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 2170;